import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function PrivacyPolicy() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="privacy-section padding-container">
      <div className="page-wrapper">
        <div className="privacy-policy">
          {/* Header Section */}
          <div className="privacy-top" data-aos="fade-up" data-aos-duration="1000">
            <div className="last-updated" data-aos="fade-up" data-aos-duration="1000">
            </div>
           
            <p>
              <strong>By using our website, you agree to this Privacy Policy.</strong>
            </p>
          </div>

          {/* Information We Collect */}
          <div className="information-collect" data-aos="fade-up" data-aos-duration="1000">
            <h1 >Information <span className="orange-text">We Collect</span></h1>
            
            <div className="collect-item" data-aos="fade-up" data-aos-duration="1000">
              <h2 >Personal Information <span className="orange-text">(Provided by You)</span>
              </h2>
              <p>
                When you contact us, apply for a position, or request a service, we may collect:
              </p>
              <ul>
                <li>Full name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Resume, portfolio, and job application details</li>
                <li>Academic and professional information (for internship/job applicants)</li>
                <li>Project details shared by clients</li>
                <li>Any files uploaded for service-related purposes</li>
              </ul>
              <p>
                We do not request sensitive documents unless required for a formal hiring process and only with your consent.
              </p>
            </div>

            <div className="collect-item" data-aos="fade-up" data-aos-duration="1000">
              <h2>Automatically <span className="orange-text">Collected Information</span></h2>
              <p>
                Through cookies and analytics tools:
              </p>
              <ul>
                <li>IP address</li>
                <li>Device information</li>
                <li>Browser type</li>
                <li>Pages visited</li>
                <li>Time spent on site</li>
                <li>Referral links</li>
              </ul>
            </div>

            <div className="collect-item" data-aos="fade-up" data-aos-duration="1000">
              <h2>Internship & Job <span className="orange-text">Applicant Information</span></h2>
              <p>
                If you apply for:
              </p>
              <ul>
                <li>3-month unpaid internship, or</li>
                <li>6-month paid internship (via PSEB or P@SHA)</li>
                <li>Job / Apprenticeship program</li>
              </ul>
              <p>
                We may collect:
              </p>
              <ul>
                <li>CV, cover letter, academic records, CNIC</li>
                <li>Portfolio links</li>
                <li>Skills assessments or test results</li>
                <li>Interview feedback</li>
              </ul>
              <div className="important-note" data-aos="fade-up" data-aos-duration="1000">
                <p>
                  <strong>Important:</strong> Applying does <strong>NOT</strong> guarantee selection, employment, 
                  internship confirmation, interview call, or future hiring.
                </p>
                <p>
                  This protects your company legally against claims.
                </p>
              </div>
            </div>
          </div>

          {/* How We Use Your Information */}
          <div className="information-use" data-aos="fade-up" data-aos-duration="1000">
            <h1 >How We Use <span className="orange-text">Your Information</span></h1>
            <p>
              We use collected information to:
            </p>
            <ul>
              <li>Respond to inquiries and service requests</li>
              <li>Process job/internship applications</li>
              <li>Assess candidates' qualifications</li>
              <li>Contact candidates regarding interviews or test tasks</li>
              <li>Deliver our services to clients</li>
              <li>Communicate project updates</li>
              <li>Improve website functionality</li>
              <li>Ensure legal and regulatory compliance</li>
            </ul>
            <p>
              We do not sell or rent any personal information.
            </p>
          </div>

          {/* Legal Basis for Processing */}
          <div className="legal-basis" data-aos="fade-up" data-aos-duration="1000">
            <h1 >Legal Basis for <span className="orange-text">Processing (GDPR-Compliant)</span></h1>
            <p>
              We process applicant, client, and visitor data based on:
            </p>
            <ul>
              <li>Legitimate interest</li>
              <li>Consent</li>
              <li>Contractual necessity</li>
              <li>Compliance with laws</li>
            </ul>
          </div>

          {/* Data Sharing */}
          <div className="data-sharing" data-aos="fade-up" data-aos-duration="1000">
            <h1>Data <span className="orange-text">Sharing</span></h1>
            <p>
              We may share data with:
            </p>
            <ul>
              <li>Internal team members who require access</li>
              <li>Government authorities (only if legally required)</li>
              <li>PSEB and P@SHA (only for candidates selected in paid internship programs)</li>
              <li>Secure third-party service providers</li>
            </ul>
            <p>
              We never share applicant or client data with advertisers or external recruiters.
            </p>
          </div>

          {/* Data Storage & Security */}
          <div className="data-security" data-aos="fade-up" data-aos-duration="1000">
            <h1>Data Storage & <span className="orange-text"> Security</span></h1>
            <p>
              We implement:
            </p>
            <ul>
              <li>Secure servers</li>
              <li>Encrypted communication</li>
              <li>Restricted internal access</li>
              <li>Regular monitoring</li>
              <li>Data minimization practices</li>
            </ul>
            <p>
              We cannot guarantee absolute security, but we take all reasonable preventive measures.
            </p>
          </div>

          {/* Data Retention */}
          <div className="data-retention" data-aos="fade-up" data-aos-duration="1000">
            <h1 >Data <span className="orange-text">Retention</span></h1>
            <ul>
              <li>Client project data: retained as required for business or legal purposes</li>
              <li>Applicant/internee data: may be retained for 6-24 months for future placement consideration</li>
              <li>You may request deletion at any time</li>
            </ul>
          </div>

          {/* Applicant & Intern Notice */}
          <div className="applicant-notice" data-aos="fade-up" data-aos-duration="1000">
            <h1 >Applicant & Intern Notice <span className="orange-text"> (Important Legal Clause)</span></h1>
            <p>
              <strong>
                By applying for any job, internship, or apprenticeship at VisionBird Technologies, you acknowledge the following:
              </strong>
            </p>

            <div className="notice-item" data-aos="fade-up" data-aos-duration="1000">
              <h2>No Guarantee <span className="orange-text"> of Hiring</span></h2>
              <p>
                Submission of an application does not guarantee:
              </p>
              <ul>
                <li>Interview call</li>
                <li>Selection</li>
                <li>Internship placement</li>
                <li>Future job offer</li>
                <li>Continuation after internship</li>
              </ul>
            </div>

            <div className="notice-item" data-aos="fade-up" data-aos-duration="1000">
              <h2>Unpaid Internship <span className="orange-text">Clause</span></h2>
              <p>
                The <strong>3-month internship is completely unpaid</strong>, and:
              </p>
              <ul>
                <li>No stipend, salary, or financial benefits are guaranteed</li>
                <li>Completion does NOT guarantee a job</li>
              </ul>
            </div>

            <div className="notice-item" data-aos="fade-up" data-aos-duration="1000">
              <h2>PSEB/P@SHA Paid <span className="orange-text">Internship Clause</span></h2>
              <p>
                For 6-month internships:
              </p>
              <ul>
                <li>Stipend is issued by PSEB or P@SHA, not by VisionBird Technologies</li>
                <li>Continuation or job placement is NOT guaranteed after completion</li>
              </ul>
            </div>

            <div className="notice-item" data-aos="fade-up" data-aos-duration="1000">
              <h2>Test Task <span className="orange-text">Clause</span></h2>
              <ul>
                <li>Test tasks or skill assessments may be required</li>
                <li>Submission of test work does not create any employment rights</li>
              </ul>
            </div>

            <p>
              <strong>These clauses legally protect your company.</strong>
            </p>
          </div>

          {/* Your Rights */}
          <div className="your-rights" data-aos="fade-up" data-aos-duration="1000">
            <h1>Your <span className="orange-text">Rights</span></h1>
            <p>
              Depending on jurisdiction, you may:
            </p>
            <ul>
              <li>Access your data</li>
              <li>Request corrections</li>
              <li>Request deletion</li>
              <li>Withdraw consent</li>
              <li>Request data export</li>
              <li>Object to data processing</li>
            </ul>
            <p>
              Email: <strong>jobs@visionbird.com</strong>
            </p>
          </div>

          {/* Third-Party Links */}
          <div className="third-party-links" data-aos="fade-up" data-aos-duration="1000">
            <h1>Third-Party <span className="orange-text">Links</span></h1>
            <p>
              We are not responsible for external website policies.
            </p>
          </div>

          {/* Children's Privacy */}
          <div className="children-privacy" data-aos="fade-up" data-aos-duration="1000">
            <h1>Children's <span className="orange-text">Privacy</span></h1>
            <p>
              We do not knowingly collect information from minors under 16.
            </p>
          </div>

          {/* Updates to Policy */}
          <div className="policy-updates" data-aos="fade-up" data-aos-duration="1000">
            <h1>Updates to <span className="orange-text">Policy</span></h1>
            <p>
              We may update this policy at any time.
            </p>
          </div>

          {/* Contact Section */}
          <div
            className="policy-contact"
            data-aos="fade-up"
            data-aos-duration="1000"
            style={{ marginBottom: "30px" }}
          >
            <h1 className="orange-text">Contact</h1>
            <p>
              <strong>VisionBird Technologies</strong><br />
              <strong>Email:</strong> info@visionbird.com<br />
              <strong>Phone:</strong> +92 301 6239096<br />
              <strong>Address:</strong> B-343, Pagganwala Street, Near Jalal Cheema Masjid, Shadman Colony, Gujrat, Punjab, Pakistan.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;